<template lang="pug">
  div
    header-without-menu
    div.content.access
      div.center-form
        div.text-center
          div: img(src="../../../assets/logo_big.png")
      b-container(style="max-width:500px")
        b-row
          b-col.mt-4(cols="12")
            h4.text-center {{$t('password_reset_desc')}}
            b-card.w-100(no-body)
              b-list-group.list-input(flush)
                b-list-group-item(v-if="!authKey")
                  b-input-group
                    b-input-group-prepend(is-text)
                      icon(name="lock")
                    b-form-input(
                      type="password",
                      autocomplete="new-password",
                      v-model="form.passwdOrigin",
                      :placeholder="$t('PW_origin')")
                b-list-group-item
                  b-input-group
                    b-input-group-prepend(is-text)
                      icon(name="lock")
                    b-form-input(
                      type="password",
                      autocomplete="new-password",
                      v-model="form.passwd",
                      :placeholder="$t('PW_new')")
                b-list-group-item
                  b-input-group
                    b-input-group-prepend(is-text)
                      icon(name="lock")
                    b-form-input(
                      type="password",
                      autocomplete="new-password",
                      v-model="form.passwdConfirm",
                      :placeholder="$t('PW_new_confirm')")
            b-row.mt-3
              b-col(cols="12")
                b-btn.w-100(@click="passwdReset") {{$t('submit')}}
</template>

<script>
import {resetPW} from '@/api/manage-auth'
import { HeaderWithoutMenu } from '../../mixins/header'
export default {
  name: 'resetpw-component',
  components: { HeaderWithoutMenu },
  methods: {
    passwdReset () {
      if (!/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,12}$/.test(this.form.passwd)) {
        this.$awn.warning(this.$t('password_requirement'))
        return undefined
      } else if (this.form.passwd !== this.form.passwdConfirm) {
        this.$awn.warning(this.$t('password_confirm'))
        return undefined
      }
      let params
      if (this.authKey !== null) {
        params = {
          key: this.authKey,
          type: 'set',
          pw: this.form.passwd
        }
      } else {
        params = {
          type: 'force_set',
          mgrid: this.userid,
          origin_pw: this.form.passwdOrigin,
          pw: this.form.passwd
        }
      }
      resetPW(params)
        .then(resp => {
          let object = resp.data.objects
          if (object.result === 'Success') {
            let params = {
              context: {path: 'password_modified'}
            }
            this.AppState.$emit('show-message-dialog', params)
            this.$router.push({name: 'login'})
          } else {
            this.$awn.warning(this.$t('password_modified_error'))
          }
        })
    }
  },
  mounted () {
    // const {key} = this.$route.query
    // if (!key) {
    //   this.$router.push({name: 'error', params: {code: '400'}})
    //   return
    // }
    // this.authKey = key

    const {key} = this.$route.query
    if (key) {
      this.authKey = key
    } else if (this.$route.params) {
      this.userid = this.$route.params.userid
    } else {
      this.$router.push({name: 'error', params: {code: '400'}})
      return
    }
  },
  data () {
    return {
      authKey: null,
      form: {
        passwd: '',
        passwdconfirm: '',
        passwdOrigin: ''
      },
      userid: null
    }
  }
}
</script>

<style lang="scss" scoped src="../access.scss"></style>
<style lang="scss" scoped>
.list-input {
  .list-group-item {
    padding: 4px;
  }
  .form-control {
    border: 0;
    &:focus { box-shadow: none; }
  }
  .input-group-text {
    color: #ccc;
    border: 0;
    background-color: transparent;
    min-width: 46px;
    svg { margin: 0 auto; }
  }
}
</style>
